import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cta", "scrollTop"]

  connect() {
    this.cardsEl = document.querySelector("[data-infinite-scroll-target='items']")
    if (!this.cardsEl) {
      this.render(false)
      return
    }
    this.observer = new IntersectionObserver(
      (entries) => this.render(entries.some((e) => e.isIntersecting)),
      { rootMargin: "-12% 0px -12% 0px" }
    )
    this.observer.observe(this.cardsEl)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  render(cardsVisible) {
    if (this.hasCtaTarget) this.ctaTarget.style.display = cardsVisible ? "none" : ""
  }

  top(event) {
    event.preventDefault()
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
}
